module.exports = __webpack_public_path__ + "img/electrodomesticos.359e384f.svg";